import Icon from '../../components/Icon.vue'

Icon.register({
  'regular/registered': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M256 8c137 0 248 111 248 248s-111 248-248 248-248-111-248-248 111-248 248-248zM256 456c110.5 0 200-89.5 200-200 0-110.5-89.5-200-200-200-110.5 0-200 89.5-200 200 0 110.5 89.5 200 200 200zM366.4 374.2c4.4 8-1.4 17.8-10.5 17.8h-42.8 0c-4 0-8.7-2.8-10.6-6.4l-47.5-89.3h-32v83.7c0 6.6-5.4 12-12 12h-38.6c-6.6 0-12-5.4-12-12v-248.3c0-6.6 5.4-12 12-12h78.7c71.3 0 101.5 32.7 101.5 85.3 0 31.6-15.2 59.3-39.5 73.2 3 4.6 0.2-0.2 53.3 96.1zM256.9 239.9c20.9 0 32.4-11.5 32.4-32.4 0-19.6-6.5-31.7-38.9-31.7h-27.4v64.1h33.9z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/regular/registered.js
// module id = 1810
// module chunks = 0